var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":"bottom"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('i',{class:_vm.type + ' helper-icon ml-default el-icon-info',style:(_vm.size)})])}
var staticRenderFns = []

export { render, staticRenderFns }